import { render, staticRenderFns } from "./TagAndSubTagsList.vue?vue&type=template&id=4778539c&scoped=true&"
import script from "./TagAndSubTagsList.vue?vue&type=script&lang=js&"
export * from "./TagAndSubTagsList.vue?vue&type=script&lang=js&"
import style0 from "./TagAndSubTagsList.vue?vue&type=style&index=0&id=4778539c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778539c",
  null
  
)

export default component.exports